import Immutable from "immutable";
import { floatToMoney } from "lib/money";

export const ClubSession = new Immutable.Record({
  id: undefined,
  description: undefined,
  price: undefined
}, "Club Session");

function buildClubSessionFromAppserver(rawClubSession) {
  return ClubSession({
    id: rawClubSession.id,
    description: rawClubSession.description,
    price: floatToMoney(rawClubSession.price)
  });
}

ClubSession.fromAppserver = buildClubSessionFromAppserver;
export default ClubSession;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/ClubBooking/ClubSession.js